import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g fillOpacity="1">
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M17.195 780.702a23.063 23.063 0 00-3.383-5.256c-.874-1.022-1.836-1.962-2.81-2.885-.761-.722-1.536-1.439-2.158-2.287-.42-.572-.772-1.21-.939-1.904-.303-1.258.027-2.607.648-3.737.364-.662.83-1.27 1.404-1.754.852-.72 1.965-1.149 3.068-1.055 1.011.086 1.957.602 2.695 1.312a6.173 6.173 0 011.486 2.268 6.173 6.173 0 011.485-2.268c.738-.71 1.684-1.226 2.696-1.312 1.103-.094 2.215.336 3.067 1.055.574.484 1.04 1.092 1.404 1.754.622 1.13.951 2.479.648 3.737-.167.694-.518 1.332-.939 1.904-.622.848-1.397 1.565-2.158 2.287-.974.923-1.935 1.863-2.81 2.885a23.062 23.062 0 00-3.383 5.256"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M216.784 991.022a23.063 23.063 0 01-3.383 5.257c-.875 1.021-1.836 1.961-2.81 2.885-.761.721-1.536 1.438-2.158 2.286-.42.573-.772 1.21-.94 1.904-.302 1.258.028 2.607.65 3.737.363.662.829 1.27 1.403 1.755.852.718 1.964 1.148 3.067 1.054 1.012-.086 1.958-.602 2.696-1.312a6.172 6.172 0 001.485-2.268c.324.858.833 1.64 1.486 2.268.738.71 1.684 1.226 2.695 1.312 1.103.094 2.216-.336 3.068-1.054.574-.484 1.04-1.093 1.404-1.755.621-1.13.95-2.479.648-3.737-.167-.694-.518-1.331-.939-1.904-.622-.848-1.397-1.565-2.158-2.286-.974-.924-1.936-1.864-2.81-2.885a23.062 23.062 0 01-3.383-5.257"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M116.967 814.076a69.186 69.186 0 00-10.147-15.77c-2.624-3.063-5.509-5.884-8.431-8.654-2.283-2.164-4.606-4.316-6.474-6.86-1.262-1.717-2.315-3.629-2.817-5.713-.908-3.774.08-7.82 1.945-11.21 1.092-1.985 2.49-3.811 4.21-5.263 2.558-2.156 5.895-3.446 9.204-3.165 3.034.259 5.872 1.808 8.087 3.937 1.96 1.884 3.486 4.232 4.456 6.805.97-2.573 2.497-4.921 4.456-6.805 2.215-2.129 5.053-3.678 8.087-3.937 3.31-.281 6.646 1.009 9.203 3.165 1.721 1.452 3.119 3.278 4.211 5.263 1.865 3.39 2.853 7.436 1.945 11.21-.502 2.084-1.555 3.996-2.817 5.714-1.868 2.543-4.191 4.695-6.474 6.859-2.922 2.77-5.807 5.59-8.431 8.655a69.187 69.187 0 00-10.147 15.77"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M116.967 957.648a69.186 69.186 0 01-10.147 15.77c-2.624 3.064-5.509 5.885-8.431 8.655-2.283 2.163-4.606 4.315-6.474 6.859-1.262 1.718-2.315 3.63-2.817 5.713-.908 3.774.08 7.82 1.945 11.21 1.092 1.986 2.49 3.812 4.21 5.263 2.558 2.157 5.895 3.446 9.204 3.165 3.034-.258 5.872-1.808 8.087-3.937 1.96-1.883 3.486-4.231 4.456-6.804.97 2.573 2.497 4.92 4.456 6.804 2.215 2.129 5.053 3.679 8.087 3.937 3.31.281 6.646-1.008 9.203-3.165 1.721-1.451 3.119-3.277 4.211-5.263 1.865-3.39 2.853-7.436 1.945-11.21-.502-2.084-1.555-3.995-2.817-5.713-1.868-2.544-4.191-4.696-6.474-6.86-2.922-2.77-5.807-5.59-8.431-8.654a69.186 69.186 0 01-10.147-15.77"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.98105 1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M27 735.552l-.711 5.649H7.94q.423-4.86 3.92-8.588l6.224-5.303q3.247-2.804 3.247-5.629 0-1.882-1.076-2.997-1.056-1.133-2.92-1.133-2.152 0-3.208 1.153-.692.768-1.057 2.363-.365 1.69-.576 1.96-.308.095-.711.095h-2.42q-.424 0-.73-.173-.135-.403-.135-.903 0-4.015 2.632-6.378 2.516-2.267 6.55-2.267 3.747 0 6.13 1.998 2.536 2.113 2.536 5.802 0 3.631-2.805 6.647-.98 1.076-5.572 4.592-3.343 2.594-4.111 4.669h8.953l.153-1.73q.212-.922 1.134-.922h1.92q1.115 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.98105 -1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-211.519-1002.606l-.71 5.648h-18.348q.422-4.86 3.919-8.588l6.225-5.302q3.246-2.805 3.246-5.63 0-1.882-1.075-2.997-1.057-1.133-2.92-1.133-2.152 0-3.209 1.153-.692.768-1.057 2.363-.365 1.69-.576 1.96-.307.095-.71.095h-2.422q-.422 0-.73-.172-.134-.404-.134-.904 0-4.015 2.632-6.378 2.517-2.267 6.551-2.267 3.746 0 6.129 1.998 2.536 2.113 2.536 5.802 0 3.631-2.805 6.647-.98 1.076-5.572 4.592-3.343 2.594-4.111 4.669h8.953l.153-1.73q.212-.922 1.134-.922h1.921q1.114 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
